<header class="header">
  <div class="left">
    <div class="facility-name">
      {{(currentPharmacy$ | async)?.name}}
    </div>
    <div class="flex space-x-2">
      <div *ngIf="(userOrdersCount$ | async) > 0 && isNotBasicPlan" class="new-order-label">
        New order available.
  
        <app-button styleClass="settings"
                    subStyle="blue"
                    class="new-orders-btn"
                    (clicked)="onReceiveOrderClick()"
        >
          <img src="assets/icons/icon-pill.svg" alt="icon-pill" />
            <span class="pill-text">Receive Order</span>  
          <span class="chips-container">{{(userOrdersCount$ | async)}}</span>
        </app-button>
      </div>
      <app-back-count-badge *ngIf="backCountEnabled$ | async"
      ></app-back-count-badge>
    </div>
  </div>

  <div class="right">
<!--    <button type="button"-->
<!--            appMenu-->
<!--            [placement]="'bottom-right'"-->
<!--            [autoClose]="'outside'"-->
<!--            [menuContent]="notificationsMenuContent"-->
<!--            triggers="manual"-->
<!--            #notificationsMenu="appMenu"-->
<!--            [offsetX]="12"-->
<!--            [offsetY]="8"-->
<!--            (click)="toggleUserMenu(notificationsMenu)"-->
<!--            [class.active]="(notifications$ | async) !== undefined && (notifications$ | async)?.items?.length > 0"-->
<!--            class="notifications-btn animation-focus-default"-->
<!--            [menuClass]="'notificationsMenuContent'"-->
<!--            [hasAnimation]="true"-->
<!--    >-->
<!--      <img [hidden]="(notifications$ | async) !== undefined && (notifications$ | async)?.items?.length > 0"-->
<!--           src="assets/icons/icon-bell-gray.svg"-->
<!--           alt="notifications-icon"-->
<!--      />-->
<!--      <img [hidden]="(notifications$ | async) === undefined || (notifications$ | async)?.items?.length === 0"-->
<!--           src="assets/icons/icon-bell.svg"-->
<!--           alt="notifications-icon"-->
<!--      />-->
<!--    </button>-->

<!--    <ng-template #notificationsMenuContent>-->
<!--      <app-notifications-dropdown-->
<!--        (linkSelected)="notificationsMenu.close()"-->
<!--        [notifications$]="notifications$"-->
<!--      ></app-notifications-dropdown>-->
<!--    </ng-template>-->

    <button (click)="lockScreen()" type="button" class="user-security-btn animation-focus-default">
      <img src="assets/icons/icon-lock-opened.svg" alt="notifications-icon" />
    </button>

    <button
      appMenu
      [placement]="'bottom-right'"
      [autoClose]="'outside'"
      [menuContent]="userMenuContent"
      triggers="manual"
      #userMenu="appMenu"
      (click)="toggleUserMenu(userMenu)"
      type="button"
      class="user-menu-btn animation-focus-default"
      [ngClass]="{'unread-message': unreadTotal > 0, 'other-user-unlocked': !activeUserIsLoggedInUser}"
      [hasAnimation]="true"
      [title]="(user$ | async)?.firstName + ' ' + (user$ | async)?.lastName"
    >
      <ng-container>
        {{(user$ | async)?.firstName[0]}}{{(user$ | async)?.lastName[0]}}
      </ng-container>
      <img *ngIf="unreadTotal > 0"
      class="ellipse-icon" src="assets/icons/icon-ellipse-red.svg" alt="icon-ellipse-red"/>
    </button>

    <ng-template #userMenuContent>
      <div class="menu-container primary fixed-width">
        <div class="menu-header">
          <div class="label">
            Signed in as
          </div>
          <div class="menu-data">
            {{(user$ | async)?.email}}
          </div>
        </div>
        
        <div class="menu-item">
          <div (click)="chooseUserMenuOption('messages')" class="option flex">
            Messages
            <div *ngIf="unreadTotal">
              <span class="chips-container !bg-[#ED5252]" *ngIf="unreadTotal > 0">{{unreadTotal}}</span>
            </div>
          </div>
        </div>
        
        <div class="menu-item" *ngIf="activeUserIsLoggedInUser">
          <div (click)="chooseUserMenuOption('profile')" class="option">
            My Profile
          </div>
        </div>
        <div appMenu
             [placement]="'left-top'"
             [autoClose]="'outside'"
             [menuContent]="changePharmacyContent"
             triggers="manual"
             #changePharmacyMenu="appMenu"
             (click)="toggleUserMenu(changePharmacyMenu)"
             class="menu-item submenu"
             *ngIf="activeUserIsLoggedInUser && (pharmacies$ | async) && (pharmacies$ | async)?.length > 1"
             [hasAnimation]="true"
        >
          <div (click)="chooseUserMenuOption('changePharmacy')"
               class="option"
          >
            Change Pharmacies
          </div>
        </div>
        <div class="menu-item">
          <div (click)="chooseUserMenuOption('logout')" class="option">
            Logout
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #changePharmacyContent>
      <div class="submenu-container primary">
        <ng-container *ngFor="let pharmacy of (pharmacies$ | async); let i = index">
          <div *ngIf="pharmacy.id !== (currentPharmacy$ | async).id"
              (click)="chooseUserMenuOption('pharmacy'); switchPharmacy(pharmacy.id)"
              class="sub-menu-item">
            {{pharmacy.name}}
          </div>
        </ng-container>
      </div>
    </ng-template>
  </div>
</header>

<!-- EDIT PROFILE DIALOG -->
<app-edit-profile-dialog *ngIf="showEditProfileDialog"
                         [show]="showEditProfileDialog"
                         (cancel)="closeEditProfileDialog()"
                         (afterSaved)="afterEditProfile($event)"
></app-edit-profile-dialog>
